// ============================================================================
// LES PLURIELS FRANÇAIS DES COMPOSANTS PARTAGÉS — et rien d'autre.
//
// UTILITÉ : le texte français EST la clé (voir `@orgazone/i18n`), donc il n'y a pas de catalogue
// français à écrire… sauf pour les phrases COMPTÉES. Sans ces entrées, un tableau filtré annoncerait
// « Filtres — 1 actifs » dans la langue de référence, c'est-à-dire chez la quasi-totalité des comptes.
//
// ⚠️ CE PAQUET N'ENREGISTRE RIEN DE LUI-MÊME (même raison que `i18n-en` / `i18n-es`) : c'est
//    l'application qui joint ce fragment au sien. Il est minuscule et STATIQUE — il voyage avec le
//    code, jamais par un aller-retour réseau.
// ============================================================================
import type { Catalogue } from '@orgazone/i18n';

export const UI_WEB_FR: Catalogue = {
  'Histogramme de {n} intervalles': { one: 'Histogramme de {n} intervalle', other: 'Histogramme de {n} intervalles' },
  'Filtres — {n} actif': { one: 'Filtres — {n} actif', other: 'Filtres — {n} actifs' },
  'Colonnes · {n} masquée': { one: 'Colonnes · {n} masquée', other: 'Colonnes · {n} masquées' },
  '{n} sélectionnée': { one: '{n} sélectionnée', other: '{n} sélectionnées' },
  '{n} sélectionné': { one: '{n} sélectionné', other: '{n} sélectionnés' },
  'Rechercher parmi {n}…': { one: 'Rechercher parmi {n}…', other: 'Rechercher parmi {n}…' },
};
